module.exports = __webpack_public_path__ + "static/react-dev-tools-flamegraph-1a901d92f3450b819be354a3b6afac86.png";